import { SessionRole } from '@sunrise-ui/api-client';
import type {
  BulkSessionDataOutput,
  SessionOutput,
} from '@sunrise-ui/api/events/api';

export const getSpeakerIds = (
  sessions?: SessionOutput[],
  bulkSessionData?: BulkSessionDataOutput,
): string[] => {
  if (!sessions || !bulkSessionData?.session_data) {
    return [];
  }

  const idSet = new Set<string>();
  sessions.forEach((session) => {
    // Find session data from bulk response
    const sessionData = bulkSessionData.session_data.find(
      (data) => data.session_id === session.id,
    );

    // Extract speaker and moderator IDs
    const speakers =
      sessionData?.data?.attendees?.filter(
        (attendee) =>
          attendee.role === SessionRole.SPEAKER ||
          attendee.role === SessionRole.MODERATOR,
      ) || [];

    // Add speaker IDs to the set
    speakers.forEach((speaker) => {
      if (speaker.user_id) idSet.add(speaker.user_id);
    });
  });

  return Array.from(idSet);
};
